import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fb-form-builder',
  templateUrl:'form-builder.component.html',
  styles: ['form-builder.component.scss']
})
export class FormBuilderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
